<template>
  <b-modal
    v-model="isOpen"
    title="Internal Note Modal"
    size="xs"
    @close="closeModal"
  >
    <div class="service_replace_modal">
      <div>
        <div class="text-center mb-5">
          <strong>INTERNAL NOTES</strong>
        </div>
        <table>
          <tbody>
            <tr v-for="(note, index) in notes" :key="index">
              <td style="font-size: 12px; white-space: nowrap">
                {{ formatDate(note.timestamp) }} - {{ note.user.name }}:
              </td>
              <td
                style="
                  font-size: 14px;
                  text-align: left;
                  padding-left: 10px;
                  padding-bottom: 10px;
                "
                v-html="note.content"
              ></td>
              <td>
                <b-button
                  v-if="canDelete(note)"
                  style="margin: 0 10px 10px"
                  type="is-danger"
                  size="is-small"
                  icon-left="close"
                  @click="removeNote(index)"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <BaseTextarea
          v-model="newNote"
          size="large"
          class="mb-4"
          :maxlength="200"
          placeholder="Add internal notes here"
          :disabled="hideElementByCondition || disableQuoteByStatus"
        />
      </div>
      <div class="is-flex is-justify-content-flex-end mt-3">
        <BaseButton
          size="small"
          :loading="loading"
          :disabled="hideElementByCondition || disableQuoteByStatus"
          @click="save"
        >
          <div slot="text">Save</div>
        </BaseButton>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";
import BaseSelect from "@/components/base-ui/BaseSelect.vue";
import BaseButton from "@/components/base-ui/BaseButton.vue";
import IconCheck from "@/components/icons/IconCheck.vue";
import { openToast } from "@/utils/utils";
import { mapGetters } from "vuex";
import clonedeep from "lodash.clonedeep";
import BaseTextarea from "@/components/base-ui/BaseTextarea.vue";
import { datesHelper } from "@/utils/dates";

export default {
  name: "NoteModal",
  components: {
    BaseTextarea,
    IconCheck,
    BaseButton,
    BaseSelect,
    Multiselect,
  },
  props: {
    isModalOpen: {
      type: Boolean,
      default: false,
    },
    closeModal: {
      type: Function,
      default: () => {},
    },
    service: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      isOpen: false,
      newNote: null,
      notes: [],
    };
  },
  watch: {
    isModalOpen(newValue) {
      this.isOpen = newValue;
      if (newValue) {
        this.notes = clonedeep(this.formItinerary[0].internal_notes ?? []);
      }

      this.$store.dispatch("shortcuts/setEnabled", !newValue);
    },
  },
  computed: {
    ...mapGetters({
      disableQuoteByStatus: "itinerary/getDisableQuoteByStatus",
      hideElementByCondition: "itinerary/getHideElementByCondition",
      formItinerary: "itinerary/getFormItinerary",
      authData: "auth/getAuthData",
    }),
  },
  methods: {
    canDelete(note) {
      return this.authData.user.id === note.user.id;
    },
    removeNote(index) {
      this.notes.splice(index, 1);
    },
    formatDate(time) {
      return datesHelper.getDatetimeFromUTC(time, "YYYY-MM-DD", " ");
    },
    async save() {
      this.loading = true;
      const user = this.authData.user;
      const note = {
        user: {
          id: user.id,
          email: user.email,
          name: user.name,
        },
        timestamp: new Date().getTime(),
        content: this.newNote,
      };
      await this.$store.dispatch("itinerary/udpateFormItineraryByKey", {
        key: "internal_notes",
        value: this.notes.concat([note]),
      });
      await this.$store.dispatch("itinerary/update", {
        ...this.formItinerary[0],
        cur_step: 1,
        last_step: 1,
      });
      this.loading = false;
      this.newNote = null;
      this.closeModal();
      openToast(
        this.$buefy,
        "Internal notes was saved successfully!",
        "is-success"
      );
    },
    addTag(newTopic) {
      this.form.topic = newTopic;
      this.options.push(newTopic);
    },
  },
};
</script>
